export default {
  formatPDF: 'pdf',
  formatCSV: 'csv',
  formatXML: 'xml',
  formatHTML: 'html',
  formatLabel(status) {
    switch(status) {
      case this.formatPDF:
        return Core.Definition.getDefinition('PDF');
        break
      case this.formatCSV:
        return Core.Definition.getDefinition('CSV');
        break
      case this.formatXML:
        return Core.Definition.getDefinition('XML');
        break
      case this.formatHTML:
        return Core.Definition.getDefinition('HTML');
        break
      default:
        return ''
        break
    }
  },
  formatOptions(keys) {
    if (keys === undefined) {
      keys = [this.formatPDF, this.formatCSV, this.formatXML, this.formatHTML]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.formatLabel(key)
          }
      )
    }
    return options
  },
  extractFields(form, fields) {
    let extractFields = []
    for(let field in fields) {
      field = fields[field]
      if (field.export !== undefined) {
        if (form[field.id]) {
          extractFields.push({
            key: field.id,
            label: field.label
          })
        }
      }
    }
    return extractFields
  }
}
